import React from 'react'

import FormControl from '@mui/material/FormControl'
import FormLabel from '@mui/material/FormLabel'
import { DatePicker } from '@mui/x-date-pickers'
import FormHelperText from '@mui/material/FormHelperText'
import TextField from '@mui/material/TextField'

const FormDatePickerWithValidation = props => {
  const { label, form, field, onChange, errors, required, children } = props

  const handleDateChange = date => {
    onChange(field, date)
  }

  return (
    <FormControl
      fullWidth
      margin='normal'
      error={errors[field]}
      required={required ? required : false}
    >
      <FormLabel htmlFor={field}>{label}</FormLabel>
      {children}
      <DatePicker
        value={form[field] === '' ? null : form[field]}
        format='MM/DD/YYYY'
        onChange={handleDateChange}
        KeyboardButtonProps={{
          'aria-label': 'change date'
        }}
        renderInput={props => (
          <TextField id={field} variant='standard' {...props} />
        )}
      />
      {errors[field] && <FormHelperText>{errors[field]}</FormHelperText>}
    </FormControl>
  )
}

export default FormDatePickerWithValidation
